/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { SmsCheck } from "./SmsCheck";

export const SmsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { absenteeismValues, setAbsenteeismValues }
) => (
  <SmsCheck
    id={row.id}
    parentId={row.parentId}
    studentName={row.studentName}
    absenteeismValues={absenteeismValues}
    setAbsenteeismValues={setAbsenteeismValues}
  />
)